<div class="wysiwyg-editor" [class.wysiwyg-editor--plain-text]="plainText"
  [attr.role]="(ariaLabelledby || ariaLabel) ? 'group' : null"
  [attr.aria-labelledby]="ariaLabelledby || null"
  [attr.aria-label]="ariaLabelledby ? null : (ariaLabel || null)">
  <div class="wysiwyg-editor__toolbar-row">
    @if (!isHtmlMode && !plainText) {
      <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
    }
    @if (isHtmlMode || plainText) {
      <div class="wysiwyg-editor__spacer"></div>
    }

    <!-- Custom toolbar buttons -->
    @if (templateVariables.length > 0 || showHtmlToggle) {
      <div class="wysiwyg-editor__custom-buttons">
        <!-- Insert Variable Dropdown -->
        @if (templateVariables.length > 0) {
          <button
            type="button"
            class="wysiwyg-editor__btn wysiwyg-editor__btn--icon"
            [matMenuTriggerFor]="variableMenu"
            aria-label="Insert variable">
            <mat-icon>data_object</mat-icon>
          </button>
        }
        <mat-menu #variableMenu="matMenu" xPosition="before" class="wysiwyg-variable-menu">
          @for (variable of templateVariables; track variable) {
            <button
              mat-menu-item
              (click)="insertVariable(variable.value)">
              {{ variable.label }}
            </button>
          }
        </mat-menu>
        <!-- Toggle HTML Source Button -->
        @if (showHtmlToggle) {
          <button
            type="button"
            class="wysiwyg-editor__btn wysiwyg-editor__btn--icon"
            [class.wysiwyg-editor__btn--active]="isHtmlMode"
            (click)="toggleHtmlMode()"
            [attr.aria-pressed]="isHtmlMode"
            aria-label="Toggle HTML source">
            <mat-icon>code</mat-icon>
          </button>
        }
      </div>
    }
  </div>

  <!-- WYSIWYG Editor -->
  @if (!isHtmlMode) {
    <ngx-editor
      [editor]="editor"
      [(ngModel)]="content"
      [placeholder]="placeholder"
      (ngModelChange)="onContentChange($event)">
    </ngx-editor>
  }

  <!-- Raw HTML Textarea -->
  @if (isHtmlMode) {
    <textarea
      class="wysiwyg-editor__html-source"
      [(ngModel)]="rawContent"
      [placeholder]="placeholder"
      [attr.aria-labelledby]="ariaLabelledby || null"
      [attr.aria-label]="ariaLabelledby ? null : (ariaLabel || null)"
      (ngModelChange)="onHtmlContentChange($event)">
    </textarea>
  }
</div>
